// extracted by mini-css-extract-plugin
export default {"centerLoader":"Page_centerLoader__-788J","placeholderText":"Page_placeholderText__rEzfj","profileCompletionBox":"Page_profileCompletionBox__KJ4JA"};